import liff from "@line/liff";
import { env } from "./env";

type Profile = Awaited<ReturnType<typeof liff.getProfile>>;

let initPromise: Promise<void> | null = null;

export function initLiff(): Promise<void> {
  if (!initPromise) {
    initPromise = liff.init({ liffId: env.liffId }).then(() => {
      if (!liff.isLoggedIn()) {
        liff.login({ redirectUri: window.location.href });
      }
    });
  }
  return initPromise;
}

export function getIdToken(): string {
  const token = liff.getIDToken();
  if (!token) throw new Error("liff_id_token_unavailable");
  return token;
}

export function getProfile(): Promise<Profile> {
  return liff.getProfile();
}

export function closeLiff() {
  if (liff.isInClient()) liff.closeWindow();
}
